import ReactDOM from 'react-dom/client';
import { AppThemeProvider } from '@app/providers/theme';
import { App } from './app';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <AppThemeProvider>
    <App />
  </AppThemeProvider>,
);
